// Constantes de `shortMessage` retornadas pela API. Centralizadas aqui para
// evitar string duplicada em multiplos arquivos — qualquer mudanca de
// contrato com o backend toca um lugar so.
export const SHORT_MESSAGE = {
  UNAUTHORIZED_TRANSACTION: "TRANSACAO_NAO_AUTORIZADA",
  CORRESPONDENT_AVAILABLE: "ChosenPlanIsNotAvailableButCorrespondentIs",
  ELIGIBILITY_INTEGRATION_ERROR: "EligibilityIntegrationError",
} as const;

export type ShortMessage = (typeof SHORT_MESSAGE)[keyof typeof SHORT_MESSAGE];

// shortMessages que a API retorna como sinalizacao de fluxo, nao como erro
// real. O app trata cada um (modal/alert) — antes de adicionar aqui,
// garantir que existe tratamento de UI; senao o erro vira silent failure.
//
// EligibilityIntegrationError: 412 retornado por /core/elegibilidade quando
// a TIM rejeita a linha (ex.: "Perfil Pre-Pago. Cliente com Restricao no
// Mercado."). O fluxo ja trata via fallback de elegibilidade-express ->
// modal de troca de pagamento; quando express tambem rejeita, cai no erro
// generico do finish-order. Em ambos os casos eh regra de negocio, nao
// erro tecnico — nao deve poluir o Sentry.
export const EXPECTED_FLOW_SHORT_MESSAGES: ReadonlySet<ShortMessage> = new Set([
  SHORT_MESSAGE.UNAUTHORIZED_TRANSACTION,
  SHORT_MESSAGE.CORRESPONDENT_AVAILABLE,
  SHORT_MESSAGE.ELIGIBILITY_INTEGRATION_ERROR,
]);
